import { Metadata } from "@dashboard/components/Metadata";
import { DashboardModal } from "@dashboard/components/Modal";
import { OrderLineWithMetadataFragment } from "@dashboard/graphql";
import { buttonMessages, commonMessages } from "@dashboard/intl";
import { Button } from "@saleor/macaw-ui-next";
import React from "react";
import { FormattedMessage } from "react-intl";

/** OrderLine has metadata/privateMetadata (ObjectWithMetadata) but generated types are stale */
type OrderLineWithMetadata = OrderLineWithMetadataFragment & {
  metadata?: Array<{ key: string; value: string }>;
  privateMetadata?: Array<{ key: string; value: string }>;
};

interface OrderMetadataDialogProps {
  open: boolean;
  onClose: () => void;
  data?: OrderLineWithMetadataFragment;
}

export const OrderMetadataDialog = ({
  onClose,
  open,
  data,
}: OrderMetadataDialogProps) => {
  const line = data as OrderLineWithMetadata | undefined;
  return (
    <DashboardModal open={open} onChange={onClose}>
      <DashboardModal.Content
        __maxHeight="90vh"
        __width="min(850px, 90vw)"
        overflowY="auto"
        gap={0}
        paddingX={0}
      >
        <DashboardModal.Title paddingX={6}>
          <FormattedMessage {...commonMessages.metadata} />:{" "}
          {data?.productName ?? ""}
        </DashboardModal.Title>

        <Metadata
          readonly={true}
          onChange={() => {}}
          data={{
            metadata:
              (line?.metadata?.length
                ? line.metadata
                : line?.variant?.metadata) ?? [],
            privateMetadata:
              (line?.privateMetadata?.length
                ? line.privateMetadata
                : line?.variant?.privateMetadata) ?? [],
          }}
        />

        <DashboardModal.Actions paddingX={6}>
          <Button data-test-id="back" variant="secondary" onClick={onClose}>
            <FormattedMessage {...buttonMessages.close} />
          </Button>
        </DashboardModal.Actions>
      </DashboardModal.Content>
    </DashboardModal>
  );
};
